import ajax from "@/lib/ajax";


// 获取水处理系统列表
export async function GetWaterMachineList(payload: any){
	let res = await ajax.get('/api/services/app/WaterMachine/GetWaterMachineList', {params:payload})
	return res.data.result
}
// 新增水处理系统
export async function InsertWaterMachine(payload: any){
	let res = await ajax.post('/api/services/app/WaterMachine/InsertWaterMachine', payload)
	return res.data.result
}
// 更新水处理系统
export async function UpdateWaterMachineById(payload: any){
	let res = await ajax.put('/api/services/app/WaterMachine/UpdateWaterMachineById', payload)
	return res.data.result
}
// 删除水处理系统
export async function DeleteWaterMachine(payload: any){
	let res = await ajax.delete('/api/services/app/WaterMachine/DeleteWaterMachine', {params:payload})
	return res.data.result
}



//水处理机器维修相关
export async function GetWaterMachineRepairList(payload: any){
	let res = await ajax.get('/api/services/app/WaterMachineRepair/GetWaterMachineRepairList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertWaterMachineRepair(payload: any){
	let res = await ajax.post('/api/services/app/WaterMachineRepair/InsertWaterMachineRepair', payload)
	return res.data.result
}
// 更新
export async function UpdateWaterMachineRepairById(payload: any){
	let res = await ajax.put('/api/services/app/WaterMachineRepair/UpdateWaterMachineRepairById', payload)
	return res.data.result
}
// 删除
export async function DeleteWaterMachineRepair(payload: any){
	let res = await ajax.delete('/api/services/app/WaterMachineRepair/DeleteWaterMachineRepair', {params:payload})
	return res.data.result
}


//水处理机器保养相关
export async function GetWaterMachineMaintainList(payload: any){
	let res = await ajax.get('/api/services/app/WaterMachineMaintain/GetWaterMachineMaintainList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertWaterMachineMaintain(payload: any){
	let res = await ajax.post('/api/services/app/WaterMachineMaintain/InsertWaterMachineMaintain', payload)
	return res.data.result
}
// 更新
export async function UpdateWaterMachineMaintainById(payload: any){
	let res = await ajax.put('/api/services/app/WaterMachineMaintain/UpdateWaterMachineMaintainById', payload)
	return res.data.result
}
// 删除
export async function DeleteWaterMachineMaintain(payload: any){
	let res = await ajax.delete('/api/services/app/WaterMachineMaintain/DeleteWaterMachineMaintain', {params:payload})
	return res.data.result
}


//水处理机器检查相关
export async function GetWaterMachineSurveyList(payload: any){
	let res = await ajax.get('/api/services/app/WaterMachineSurvey/GetWaterMachineSurveyList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertWaterMachineSurvey(payload: any){
	let res = await ajax.post('/api/services/app/WaterMachineSurvey/InsertWaterMachineSurvey', payload)
	return res.data.result
}
// 更新
export async function UpdateWaterMachineSurveyById(payload: any){
	let res = await ajax.put('/api/services/app/WaterMachineSurvey/UpdateWaterMachineSurveyById', payload)
	return res.data.result
}
// 删除
export async function DeleteWaterMachineSurvey(payload: any){
	let res = await ajax.delete('/api/services/app/WaterMachineSurvey/DeleteWaterMachineSurvey', {params:payload})
	return res.data.result
}



//环境管理相关
export async function GetEnvironmentJcList(payload: any){
	let res = await ajax.get('/api/services/app/EnvironmentJc/GetEnvironmentJcList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertEnvironmentJc(payload: any){
	let res = await ajax.post('/api/services/app/EnvironmentJc/InsertEnvironmentJc', payload)
	return res.data.result
}
// 更新
export async function UpdateEnvironmentJcById(payload: any){
	let res = await ajax.put('/api/services/app/EnvironmentJc/UpdateEnvironmentJcById', payload)
	return res.data.result
}
// 删除
export async function DeleteEnvironmentJc(payload: any){
	let res = await ajax.delete('/api/services/app/EnvironmentJc/DeleteEnvironmentJc', {params:payload})
	return res.data.result
}



//透析液 相关
export async function GetDialysateJcList(payload: any){
	let res = await ajax.get('/api/services/app/DialysateJc/GetDialysateJcList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertDialysateJc(payload: any){
	let res = await ajax.post('/api/services/app/DialysateJc/InsertDialysateJc', payload)
	return res.data.result
}
// 更新
export async function UpdateDialysateJcById(payload: any){
	let res = await ajax.put('/api/services/app/DialysateJc/UpdateDialysateJcById', payload)
	return res.data.result
}
// 删除
export async function DeleteDialysateJc(payload: any){
	let res = await ajax.delete('/api/services/app/DialysateJc/DeleteDialysateJc', {params:payload})
	return res.data.result
}



//透析机 相关
export async function GetMachineListByWardOrChangJ(payload: any){
	let res = await ajax.get('/api/services/app/Machine/GetMachineListByWardOrChangJ', {params:payload})
	return res.data.result
}
// 新增
export async function InsertMachine(payload: any){
	let res = await ajax.post('/api/services/app/Machine/InsertMachine', payload)
	return res.data.result
}
// 更新
export async function UpdateMachineById(payload: any){
	let res = await ajax.put('/api/services/app/Machine/UpdateMachineById', payload)
	return res.data.result
}
// 删除
export async function DeleteMachine(payload: any){
	let res = await ajax.delete('/api/services/app/Machine/DeleteMachine', {params:payload})
	return res.data.result
}




//透析机消毒 相关
export async function GetMachineDisinfectList(payload: any){
	let res = await ajax.get('/api/services/app/MachineDisinfect/GetMachineDisinfectList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertMachineDisinfect(payload: any){
	let res = await ajax.post('/api/services/app/MachineDisinfect/InsertMachineDisinfect', payload)
	return res.data.result
}
// 更新
export async function UpdateMachineDisinfectById(payload: any){
	let res = await ajax.put('/api/services/app/MachineDisinfect/UpdateMachineDisinfectById', payload)
	return res.data.result
}
// 删除
export async function DeleteMachineDisinfect(payload: any){
	let res = await ajax.delete('/api/services/app/MachineDisinfect/DeleteMachineDisinfect', {params:payload})
	return res.data.result
}


//透析机维修 相关
export async function GetMachineRepairList(payload: any){
	let res = await ajax.get('/api/services/app/MachineRepair/GetMachineRepairList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertMachineRepair(payload: any){
	let res = await ajax.post('/api/services/app/MachineRepair/InsertMachineRepair', payload)
	return res.data.result
}
// 更新
export async function UpdateMachineRepairById(payload: any){
	let res = await ajax.put('/api/services/app/MachineRepair/UpdateMachineRepairById', payload)
	return res.data.result
}
// 删除
export async function DeleteMachineRepair(payload: any){
	let res = await ajax.delete('/api/services/app/MachineRepair/DeleteMachineRepair', {params:payload})
	return res.data.result
}

//透析机保养 相关
export async function GetMachineMaintainList(payload: any){
	let res = await ajax.get('/api/services/app/MachineMaintain/GetMachineMaintainList', {params:payload})
	return res.data.result
}
// 新增
export async function InsertMachineMaintain(payload: any){
	let res = await ajax.post('/api/services/app/MachineMaintain/InsertMachineMaintain', payload)
	return res.data.result
}
// 更新
export async function UpdateMachineMaintainById(payload: any){
	let res = await ajax.put('/api/services/app/MachineMaintain/UpdateMachineMaintainById', payload)
	return res.data.result
}
// 删除
export async function DeleteMachineMaintain(payload: any){
	let res = await ajax.delete('/api/services/app/MachineMaintain/DeleteMachineMaintain', {params:payload})
	return res.data.result
}




// WEBPACK FOOTER //
// ./src/api/engineer/index.ts